/* =============================================================================
   BUNI USA — Wishlist module
   Mirrors the React wishlist behavior from www/src/pages/Product.tsx /
   www/src/pages/Wishlist.tsx: a localStorage-backed list of product *handles*
   under the key "buni_wishlist". Exposes a global `window.BuniWishlist` with:
     - toggle(handle, btnEl)  -> add/remove the handle, reflect state on btnEl
     - has(handle)            -> boolean
     - list()                 -> array of handles
   The standalone wishlist PAGE is a separate task; this only powers the button.
   ============================================================================= */
(function () {
  'use strict';

  var STORAGE_KEY = 'buni_wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* storage unavailable — fail quietly, matching the React try/catch */
    }
  }

  function has(handle) {
    if (!handle) return false;
    return read().indexOf(handle) !== -1;
  }

  function list() {
    return read();
  }

  function reflect(btnEl, wishlisted) {
    if (!btnEl) return;
    btnEl.classList.toggle('is-wishlisted', !!wishlisted);
    btnEl.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
  }

  function toggle(handle, btnEl) {
    if (!handle) return false;
    var handles = read();
    var idx = handles.indexOf(handle);
    var nowWishlisted;
    if (idx === -1) {
      handles.push(handle);
      nowWishlisted = true;
    } else {
      handles.splice(idx, 1);
      nowWishlisted = false;
    }
    write(handles);
    reflect(btnEl, nowWishlisted);
    // Notify any listeners (e.g. a future wishlist page) of the change.
    try {
      window.dispatchEvent(
        new CustomEvent('wishlist:changed', { detail: { handle: handle, wishlisted: nowWishlisted } })
      );
    } catch (e) {
      /* CustomEvent unsupported — ignore */
    }
    return nowWishlisted;
  }

  // Reflect initial state for any wishlist buttons already in the DOM.
  function init() {
    var buttons = document.querySelectorAll('[data-buni-wishlist-handle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      reflect(btn, has(btn.getAttribute('data-buni-wishlist-handle')));
    }
  }

  window.BuniWishlist = {
    toggle: toggle,
    has: has,
    list: list,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
